
import EVENTS from '@shared/events';

class BethistoryController {
  constructor(BetHistoryApiService, SessionService, EventDispatcherService, $document, $timeout) {
    'ngInject';

    this.BetHistoryApiService = BetHistoryApiService;
    this.SessionService = SessionService;
    this.EventDispatcherService = EventDispatcherService;
    this.htmlDocument = $document[0];
    this.$timeout = $timeout;
  }

  $onInit() {
    this.endPoint = 10;
    this.offset = 1;
    this.currentPage = 1;
    this.currentDate = '';
    this.maxSize = 5;
    this.limit = 10;
    this.selectlimit = 10;
    this.textDisplay = 'Loading...';
    this.changelimit = '10';
    this.recordsTotal = 0;
    this.noOfPages = 0;
    this.brokerageSyncId = this.SessionService.get('brokerageSyncId');

    this.subscription = this.EventDispatcherService.addListener(EVENTS.BET_PROCESSED, event => this.drawSettledBetSummary());

    this.drawSettledBetSummary();
  }

  renderTable() {
    this.$timeout(() => {
      $('#datatable-responsive').footable();
      $('#datatable-responsive').trigger('footable_redraw');

      var screen = $(window);
      if (screen.width() < 768) {
        $('#betDetailsModal').on('shown.bs.modal', function (e) {
          $('#betHistoryDetails').footable();
          $('#betHistoryDetails').trigger('footable_redraw');
        });
      } else {
        $('#betHistoryDetails').footable();
        $('#betHistoryDetails').trigger('footable_redraw');
      }

    }, 0);
  }

  drawSettledBetSummary() {
    this.limit = this.changelimit ? this.changelimit : this.limit;
    let betSummaryLink = `/brokerage/get-settled-bet-summary${this.getLink()}`;
    this.htmlDocument.getElementById('btnSearch').innerHTML = 'Searching...';

    this.BetHistoryApiService.getSettledBetSummary(betSummaryLink).then((response) => {
      let summaryData = response.data;
      this.recordsTotal = response.recordsTotal;

      this.summaryBets = summaryData.map((value) => {
        let summary = value;
        summary.stake = this.formatAmount(value.stake);
        summary.turnover = this.formatAmount(value.turnover);
        /*jshint camelcase: false */
        summary.winLossAmount = this.formatAmount(value.win_loss_amount);

        return summary;
      });

      if(this.recordsTotal === 0) {
        this.textDisplay = 'No results to display!';
      }

      this.htmlDocument.getElementById('btnSearch').innerHTML = 'Search';
      this.noOfPages = Math.floor(this.recordsTotal / this.limit) + 1;

      this.renderTable();
    });
  }

  resetForm() {
    this.htmlDocument.getElementById('dateTo').getElementsByClassName('filter-from-date')[0].value = '';
    this.htmlDocument.getElementById('dateFrom').getElementsByClassName('filter-from-date')[0].value = '';

    this.drawSettledBetSummary();
  }

  getLink() {
    let dateFrom = this.htmlDocument.getElementById('dateFrom').getElementsByClassName('filter-from-date')[0].value;
    let dateTo = this.htmlDocument.getElementById('dateTo').getElementsByClassName('filter-from-date')[0].value;
    let paramText = `?id=${this.brokerageSyncId}&limit=${this.limit}&offset=${(this.offset - 1)}&from=${dateFrom}&to=${dateTo}`;

    return paramText;
  }

  changeLimit() {
    this.currentPage = 1;
    this.changelimit = this.htmlDocument.getElementById('betHistoryLength').value;
    this.endPoint = this.changelimit;
    this.offset = 1;
    this.drawSettledBetSummary();
  }

  viewBetDetails(date, id) {
    this.betList = [];

    let previousInnerHtml = this.htmlDocument.getElementById('btnViewBets' + id).value;
    this.htmlDocument.getElementById('btnViewBets' + id).value = 'Loading...';

    let betLinkDetails = `/brokerage/get-bet-list?id=${this.brokerageSyncId}&date=${date}`;
    this.BetHistoryApiService.getBetList(betLinkDetails).then((response) => {
      let betData = response.data;
      this.betList = betData.map((value) => {
        let bet = value;
        bet.stake = this.formatAmount(value.stake);
        bet.turnover = this.formatAmount(value.turnover);
        bet.odds = this.formatAmount(value.odds);
        bet.winLoss = this.formatAmount(value.winLoss);
        bet.bet = this.betSelected(value);
        bet.home = this.betDetails(value);
        bet.result = this.betStatus(value.result);
        bet.betOption = JSON.parse(value.betOption);

        return bet;
      });

      this.currentDate = this.formatdate(date);
      this.htmlDocument.getElementById('btnViewBets' + id).value = previousInnerHtml;
      $('#betDetailsModal').modal('show');
    });
  }

  formatdate(date) {
    let key = date.split('-');

    return `${key[1]}/${key[2]}/${key[0]}`;
  }

  betDetails(data) {
    let betRequestType = parseInt(data.betRequestType);

    switch (betRequestType) {
    case 0:
      let texta = `${this.halfFullTime(data.halftimeBet)}/${this.betType(data.betType)}:`;
      let textb = ` ${data.home} VS ${data.away} ${this.currentScore(data.currentScore)}`;

      return `${texta}${textb}`;
    case 1:
      return `${data.home} VS ${data.away}`;
    default:
      return data.away;
    }
  }

  betSelected(data) {
    if (data.betRequestType === 0) {
      let bet = parseInt(data.bet);

      switch (bet) {
      case 0:
        bet = 'DRAW ';
        break;
      case 1:
        bet = 'HOME ';
        break;
      case 2:
        bet = 'AWAY ';
        break;
      case 3:
        bet = 'UNDER ';
        break;
      case 4:
        bet = 'OVER ';
        break;
      }

      return bet + this.handicap(data);
    }

    let betOption = angular.fromJson(data.betOption);

    if (data.betRequestType === 1) {
      return betOption.special;
    }

    return '';
  }

  handicap(data) {
    return (0 > data.betType ? '' : this.formatAmount(data.handicap));
  }

  halfFullTime(value) {
    return (!value ? 'FT' : 'HT');
  }


  betType(value) {
    value = parseInt(value);

    switch (value) {
    case 0:
      return 'AHDP';
    case 1:
      return 'OU';
    default:
      return '1X2';
    }
  }

  currentScore(value) {
    return (value ? ` (${value})` : '');
  }

  formatAmount(value) {
    let sign = 0 > value ? '-' : '';
    value = parseFloat((Math.abs(value)).toFixed(4));
    let count = (value.toString().split('.')[1] ? value.toString().split('.')[1].length : 0);

    switch (count) {
    case 0:
      value = sign + value + '.00';
      break;
    case 1:
      value = sign + value + '0';
      break;
    default:
      value = sign + value;
      break;
    }
    let components = value.toString().split('.');
    components[0] = components[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return components.join('.');
  }

  betStatus(value) {
    value = parseInt(value);

    switch (value) {
    case 0:
      return 'Voided';
    case 1:
      return 'Win';
    case 2:
      return 'Half Win';
    case 3:
      return 'Lose';
    case 4:
      return 'Half Lose';
    case 5:
      return 'Stake Returned';
    }
  }

  range(current, noOfPages) {
    this.output = [];
    let min = 0;
    let max = 0;
    if (current < 5 && (noOfPages - current) > 3) {
      min = 1;
      max = 5;
    } else if (noOfPages < 5 && noOfPages > 1) {
      min = 1;
      max = noOfPages;
    } else if ((noOfPages - current) > 3) {
      min = current - 1;
      max = current + 1;
    } else if ((noOfPages - current) <= 3 && noOfPages !== 1) {
      min = noOfPages - 4;
      max = noOfPages;
    }

    if (max !== 0) {
      for (this.i = min; this.i <= max; this.i += 1) {
        this.output.push(this.i);
      }
    }

    return this.output;
  }

  jumpTo(current, noOfPages) {
    this.endPoint = this.limit * current;
    this.offset = (this.limit * current) - this.limit;
    this.offset = this.offset + 1;
    this.currentPage = current;
    this.drawSettledBetSummary();
  }
}

export default BethistoryController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/bethistory/bethistory.controller.js